import { Typography } from '@material-ui/core';
import { lightColorPalette } from '@linearb/linui-common';

const InactiveTooltipTitle = () => {
  return (
    <Typography color={lightColorPalette.lbGreyDark} fontSize='1.1rem'>
      Not available when no activity is found
    </Typography>
  );
};

export default InactiveTooltipTitle;
